/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_DELETEVIDEONOTE,DELETEVIDEONOTE_RECEIVED } = constants.DeleteVideoNoteConstant;

export default {
    REQUEST_DELETEVIDEONOTE,
    DELETEVIDEONOTE_RECEIVED,

  requestDeleteVideoNoteNote: payload => ({
    type: REQUEST_DELETEVIDEONOTE,
    payload
  }),
  DeleteVideoNoteReceived: () => ({
    type: DELETEVIDEONOTE_RECEIVED
  }),
};
